import { render, staticRenderFns } from "./SatellitePlatforms.vue?vue&type=template&id=a3ce6f54&scoped=true"
import script from "./SatellitePlatforms.vue?vue&type=script&lang=js"
export * from "./SatellitePlatforms.vue?vue&type=script&lang=js"
import style0 from "./SatellitePlatforms.vue?vue&type=style&index=0&id=a3ce6f54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3ce6f54",
  null
  
)

export default component.exports